import ReactDOM from "react-dom/client";

export default ReactDOM;
export const { createRoot, hydrateRoot, version } = ReactDOM;
// This file exists simply to apply __esModule: true to the module
export const __esModule = true;
